import { Plus } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';

import { openScheduleSession } from '@/features/session/schedule-session';

export function CalendarPageCreateButton() {
    return (
        <Button
            size="icon-lg"
            aria-label="Create"
            className="fixed right-3 bottom-4 z-10 shadow-none drop-shadow-sm"
            onClick={() => openScheduleSession()}
        >
            <Plus aria-hidden="true" />
        </Button>
    );
}
